import { adminRoutes } from 'modules/admin/routes/constants';

export const adminCareerRoutes = {
  root: `${adminRoutes.root}/career`,
  positions: `${adminRoutes.root}/career/positions`,
  applications: `${adminRoutes.root}/career/applications`,
};
